import {IPrice} from "../services/order-service";

export function formatPrice (price: IPrice) {
	let formattedPrice = '';

	const replaceDecimalSeparatorInPrice = (amount: number, decimalSeparator: string) => {
		return amount.toFixed(2).replace('.', decimalSeparator);
	};

	if (price.Currency.DisplayLeftToPrice)
		formattedPrice += price.Currency.CurrencySymbol + ' ' + replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator);
	else
		formattedPrice += replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator) + ' ' + price.Currency.CurrencySymbol;
	return formattedPrice;
}

